import { Button, FloatingLabel, Form } from 'react-bootstrap'

const QUICK_QTY_PRESETS = ['1', '2', '3', '4']

const toNumber = (value) => {
  const parsed = Number(String(value ?? '').replace(',', '.'))
  return Number.isFinite(parsed) ? parsed : 0
}

const formatQuantity = (value) => Number.isInteger(value) ? String(value) : String(value).replace('.', ',')

const OrderItemControls = ({
  activeItem,
  quantity,
  setQuantity,
  discount,
  setDiscount,
  selected,
  onAdd,
  onBack,
  addTitle,
}) => {
  const disabled = !activeItem
  const changeQuantity = (step) => {
    setQuantity(formatQuantity(Math.max(toNumber(quantity) + step, 0)))
  }

  return (
    <div className="admin-order-item-controls d-flex align-items-center flex-nowrap">
      <Button type="button" variant="outline-secondary" className="admin-order-qty-step fs-5" disabled={disabled} onClick={() => changeQuantity(-1)} aria-label="Snížit počet">
        <i className="bi bi-dash-lg"></i>
      </Button>
      <Form.Control
        type="text"
        className="admin-order-qty-input text-center fs-5"
        value={quantity}
        disabled={disabled}
        aria-label="Počet měrných jednotek"
        onFocus={(event) => setTimeout(() => event.target.select(), 0)}
        onChange={(event) => setQuantity(event.target.value)}
      />
      <Button type="button" variant="outline-secondary" className="admin-order-qty-step fs-5" disabled={disabled} onClick={() => changeQuantity(1)} aria-label="Zvýšit počet">
        <i className="bi bi-plus-lg"></i>
      </Button>
      {QUICK_QTY_PRESETS.map((preset) => (
        <Button
          key={preset}
          type="button"
          variant={String(quantity) === preset ? 'primary' : 'outline-primary'}
          className="admin-order-qty-preset fs-5"
          disabled={disabled}
          onClick={() => setQuantity(preset)}
        >
          {preset}
        </Button>
      ))}
      <FloatingLabel label="sleva %" className="admin-order-discount">
        <Form.Control
          type="number"
          value={discount}
          disabled={disabled}
          onFocus={(event) => setTimeout(() => event.target.select(), 0)}
          onChange={(event) => setDiscount(event.target.value)}
        />
      </FloatingLabel>
      <Button type="button" className="admin-order-item-add" disabled={disabled || selected} onClick={onAdd} title={addTitle}>
        <i className={`bi ${selected ? 'bi-check2-circle' : 'bi-plus-circle'} me-2`}></i>{selected ? 'Přidáno' : 'Přidat'}
      </Button>
      <Button type="button" variant="secondary" className="admin-order-item-back" onClick={onBack}>
        <i className="bi bi-arrow-left me-2"></i>Zpět
      </Button>
    </div>
  )
}

export default OrderItemControls
